import React, { useState, useEffect } from "react";
import {
  ListGroup,
  ListGroupItem,
  Badge,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import { Link } from "react-router-dom";

//Componentes
import AssignButton from "../buttons/AssignButton";
import GrupoAPEButton from "../buttons/GrupoAPEButton";
import OnHoldAPEButton from "../buttons/OnHoldAPEButton";

const ListadoAPE = (props) => {
  const itemsPerPage = 100;
  const [page, setPage] = useState(0);
  const [arrayToShow, setArrayToShow] = useState([]);
  const [pages, setPages] = useState([]);
  const procesoHabAux = ["reclutamiento", "contratacion"];

  useEffect(() => {
    console.log("props", props);
    divideArr();
  }, [page, props]);

  const divideArr = () => {
    let numPages = [0];
    if (props.listaSolicitudes && props.listaSolicitudes.length) {
      console.log("length", props.listaSolicitudes.length);
      console.log("itemsPerPage", itemsPerPage);
      console.log("%", props.listaSolicitudes.length % itemsPerPage);
      if (props.listaSolicitudes.length % itemsPerPage === 0) {
        numPages = [
          ...Array(parseInt(props.listaSolicitudes.length / itemsPerPage)),
        ];
      } else {
        const int = parseInt(props.listaSolicitudes.length / itemsPerPage + 2);
        numPages = [...Array(int).keys()].slice(1);
      }
      const newArr = props.listaSolicitudes.slice(
        page * itemsPerPage,
        page * itemsPerPage + itemsPerPage
      );
      setArrayToShow(newArr);
      console.log("numPages", numPages);
      setPages(numPages);
    }
  };

  if (props.listaSolicitudes && props.listaSolicitudes.length > 0) {
    return (
      <>
        <ListGroup>
          {arrayToShow.map((solicitud, index) => {
            return (
              <div
                key={`divG_reclutamiento_${index}`}
                className="reclutamiento-list-item"
              >
                <ListGroupItem
                  key={`lisItem_reclutamiento_${index}`}
                  color={solicitud.color}
                >
                  <div
                    key={`div_reclutamiento_${index}`}
                    className="reclutamiento-list-area"
                  >
                    {/* {!procesoHabAux.includes(props.proceso) ? <Link key={`link_reclutamiento_${index}`} to={`${props.linkTo}${solicitud.id}`}>
                                            {`Solicitud ${solicitud.id} - ${solicitud.cargo}`}
                                        </Link> : <span>{`Solicitud ${solicitud.id} - ${solicitud.cargo}`}</span>} */}
                    {!props.disabled ? (
                      <Link
                        disabled={true}
                        key={`link_reclutamiento_${index}`}
                        to={`${props.linkTo}${solicitud.id}`}
                      >
                        {`Solicitud ${solicitud.id} - ${solicitud.cargo}`}
                      </Link>
                    ) : (
                      <>{`Solicitud ${solicitud.id} - ${solicitud.cargo}`}</>
                    )}
                    <div className="reclutamiento-list-buttons">
                      {solicitud.perteneceGrupo ? (
                        <div className="reclutamiento-list-buttons-item">
                          <GrupoAPEButton grupo={solicitud.grupo} />
                        </div>
                      ) : null}
                      {solicitud.suspendida ? (
                        <div className="reclutamiento-list-buttons-item">
                          <OnHoldAPEButton disabled={true} />
                        </div>
                      ) : null}
                      {procesoHabAux.includes(props.proceso) &&
                      props.enableButton ? (
                        <div className="reclutamiento-list-buttons-item">
                          <AssignButton
                            onClick={() => {
                              props.onClickAux(solicitud.id);
                            }}
                          />
                        </div>
                      ) : null}
                      {solicitud.nombreCandidato ? (
                        <div className="reclutamiento-list-buttons-item">
                          <Badge
                            key={`badge_reclutamiento_nombre_candidato_${index}`}
                            color="info"
                            pill
                          >
                            {solicitud.nombreCandidato}
                          </Badge>
                        </div>
                      ) : null}
                      {solicitud.cedulaCandidato ? (
                        <div className="reclutamiento-list-buttons-item">
                          <Badge
                            key={`badge_reclutamiento_cedula_candidato_${index}`}
                            color="info"
                            pill
                          >
                            {solicitud.cedulaCandidato}
                          </Badge>
                        </div>
                      ) : null}
                      <div className="reclutamiento-list-buttons-item">
                        <Badge
                          key={`badge_reclutamiento_nombre-responsable_${index}`}
                          color="light"
                          pill
                        >
                          {solicitud.name}
                        </Badge>
                      </div>
                      <div className="reclutamiento-list-buttons-item">
                        <Badge
                          key={`badge_reclutamiento_campo${index}`}
                          color="light"
                          pill
                        >
                          {solicitud.campo}
                        </Badge>
                      </div>
                      <div className="reclutamiento-list-buttons-item">
                        <Badge
                          key={`badge_reclutamiento_cliente_comercial${index}`}
                          color="light"
                          pill
                        >
                          {solicitud.cliente}
                        </Badge>
                      </div>
                      <div className="reclutamiento-list-buttons-item">
                        <Badge
                          key={`badge_reclutamiento_${index}`}
                          color="light"
                          pill
                        >
                          {solicitud.estado}
                        </Badge>
                      </div>
                    </div>
                  </div>
                </ListGroupItem>
              </div>
            );
          })}
        </ListGroup>
        <div className="ape-list-pagination">
          <Pagination size="sm">
            {/* <PaginationItem disabled={page === 0}>
                        <PaginationLink
                            onClick={() => setPage(0)}
                            first
                        />
                    </PaginationItem> */}
            <PaginationItem disabled={page === 0}>
              <PaginationLink
                onClick={() => setPage(page > 0 ? page - 1 : 0)}
                previous
              />
            </PaginationItem>
            {pages.map((pageInd) => {
              console.log("pages", pages);
              return (
                <PaginationItem>
                  <PaginationLink onClick={() => setPage(page)}>
                    {pageInd}
                  </PaginationLink>
                </PaginationItem>
              );
            })}
            <PaginationItem disabled={page === pages.length - 1}>
              <PaginationLink
                next
                onClick={() =>
                  setPage(page < pages.length - 1 ? page + 1 : pages.length - 1)
                }
              />
            </PaginationItem>
            {/* <PaginationItem disabled={page === pages.length - 1}>
                        <PaginationLink
                            last
                            onClick={() => setPage(pages.length - 1)}
                        />
                    </PaginationItem> */}
          </Pagination>
        </div>
      </>
    );
  } else {
    return (
      <div className="ape-list-nodata-text">
        <p>No hay aprobaciones</p>
      </div>
    );
  }
};

export default ListadoAPE;
